import React from "react";
import { useSelector } from "react-redux";

import { hallsSelector } from "../../../../redux/halls/selectors";

import styles from "./HallTitle.module.scss";

export const HallTitle: React.FC = () => {
  const { lastSelectedHall } = useSelector(hallsSelector);
  
  if (!lastSelectedHall) {
    return null;
  }

  const firstImage = lastSelectedHall.images && lastSelectedHall.images.length > 0
    ? lastSelectedHall.images[0].url
    : lastSelectedHall.image_url || null;

  return (
    <div className={styles.hallTitle}>
      {firstImage && (
        <div className={styles.imageWrapper}>
          <img 
            src={firstImage} 
            alt={lastSelectedHall.title}
            className={styles.image}
          />
          <div className={styles.overlay} />
          <div className={styles.title}>{lastSelectedHall.title}</div>
        </div>
      )}
      {!firstImage && (
        <div className={styles.titleOnly}>{lastSelectedHall.title}</div>
      )}
    </div>
  );
};
